var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyCart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 488,
    height: 66,
    viewBox: "0 0 488 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_19240",
    "data-name": "Group 19240",
    transform: "translate(-1268 -484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2520",
    "data-name": "Rectangle 2520",
    transform: "translate(1268 484)",
    fill: "#feeaeb",
    stroke: "#fb3640",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 488,
    height: 66,
    rx: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 487,
    height: 65,
    rx: 9.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    id: "Cart_is_empty",
    "data-name": "Cart is empty",
    transform: "translate(1489 524)",
    fill: "#fb3640",
    fontSize: 18,
    fontFamily: "Ubuntu-Regular, Ubuntu"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Cart is empty")), /*#__PURE__*/React.createElement("g", {
    id: "empty-cart-svgrepo-com",
    transform: "translate(1415.624 500.365)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2240",
    "data-name": "Path 2240",
    d: "M104.418,110.058a1.078,1.078,0,0,0,1.071.967,1.094,1.094,0,0,0,.112-.006,1.078,1.078,0,0,0,.961-1.183l-.5-4.809a1.078,1.078,0,1,0-2.144.222Z",
    transform: "translate(-79.242 -89.107)",
    fill: "#fb3640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2241",
    "data-name": "Path 2241",
    d: "M148.588,111.019a1.094,1.094,0,0,0,.112.006,1.078,1.078,0,0,0,1.071-.967l.5-4.809a1.078,1.078,0,0,0-2.144-.222l-.5,4.809A1.078,1.078,0,0,0,148.588,111.019Z",
    transform: "translate(-116.666 -89.106)",
    fill: "#fb3640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2242",
    "data-name": "Path 2242",
    d: "M76.4,185.088a3.336,3.336,0,1,0,3.336,3.336A3.34,3.34,0,0,0,76.4,185.088Zm0,4.517a1.181,1.181,0,1,1,1.181-1.181A1.182,1.182,0,0,1,76.4,189.605Z",
    transform: "translate(-52.823 -158.491)",
    fill: "#fb3640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    "data-name": "Path 2243",
    d: "M153.839,185.088a3.336,3.336,0,1,0,3.336,3.336A3.34,3.34,0,0,0,153.839,185.088Zm0,4.517a1.181,1.181,0,1,1,1.181-1.181A1.182,1.182,0,0,1,153.839,189.605Z",
    transform: "translate(-119.135 -158.491)",
    fill: "#fb3640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    "data-name": "Path 2244",
    d: "M41.151,51.108a1.078,1.078,0,0,0-.853-.419H18.816l-.9-3.469a1.078,1.078,0,0,0-1.043-.806H12.454a1.078,1.078,0,0,0,0,2.155h3.584l.895,3.441c0,.019.009.038.015.057l3.328,12.8a1.078,1.078,0,0,0,1.043.806H36.963a1.078,1.078,0,0,0,1.043-.806l3.335-12.825A1.078,1.078,0,0,0,41.151,51.108ZM36.13,63.515H22.151l-2.775-10.67H38.9Z",
    transform: "translate(0 -39.744)",
    fill: "#fb3640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    "data-name": "Path 2245",
    d: "M83.476,21.7A1.078,1.078,0,0,0,85,20.173L81.61,16.785a1.078,1.078,0,1,0-1.524,1.524Z",
    transform: "translate(-58.566 -14.103)",
    fill: "#fb3640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    "data-name": "Path 2246",
    d: "M152.752,22.016a1.075,1.075,0,0,0,.762-.316l3.384-3.387a1.078,1.078,0,1,0-1.525-1.523l-3.384,3.387a1.078,1.078,0,0,0,.762,1.839Z",
    transform: "translate(-120.138 -14.106)",
    fill: "#fb3640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    "data-name": "Path 2247",
    d: "M128.585,6.942h0a1.078,1.078,0,0,0,1.078-1.077V1.078A1.078,1.078,0,0,0,128.587,0h0a1.078,1.078,0,0,0-1.078,1.077V5.864A1.078,1.078,0,0,0,128.585,6.942Z",
    transform: "translate(-99.444)",
    fill: "#fb3640"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/empty-cart.3a9729deac1c7bd0580d331f70891c7a.svg";
export { ForwardRef as ReactComponent };